module.exports = __webpack_public_path__ + "static/media/group-3.87e855ec.png";